module.exports = __webpack_public_path__ + "img/pyme-icon.06ad49b2.svg";